// extracted by mini-css-extract-plugin
module.exports =  {"header":"_6c97079b1b--header--HiM6g"};